export const settings_intro = {
  title: "Account settings",
};
